var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("span", [_vm._v("机框出库信息")]),
              _c(
                "el-button",
                {
                  staticClass: "float-right",
                  attrs: { type: "text" },
                  on: {
                    click: function($event) {
                      return _vm.$router.go(-1)
                    }
                  }
                },
                [_vm._v("返回")]
              )
            ],
            1
          ),
          _c(
            "el-form",
            { attrs: { model: _vm.form, inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "工单ID" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.TicketId,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "TicketId", $$v)
                      },
                      expression: "form.TicketId"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.ticketData.length
            ? _c(
                "el-table",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { data: _vm.ticketData, border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "ticket_id", label: "工单号", width: "150" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "assetId", label: "固资", width: "150" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "idcName", label: "机房单元" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "idcpName", label: "一级机房" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "model", label: "机型", width: "180" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "eventTypex", label: "异常类型" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "sn", label: "sn", width: "80" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "handleDetail",
                      label: "异常类型结单描述",
                      width: "100"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "posName", label: "机位", width: "80" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "is_ai_model",
                      label: "是否AI服务器",
                      width: "80"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "rackName", label: "机架", width: "80" }
                  })
                ],
                1
              )
            : _c("el-empty", { attrs: { description: "暂无数据" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }